const Contact = () => {
    return (
        <>
            <div className="slide" id="contact">
                <div className="wrapper">
                    <h1>Contacte-nous</h1>
                    <div className="container-contact">
                        <div className="gauche">
                            <div id="way">
                                <p>Ou viens nous voir !</p>
                                <img src="/images/arrow3.svg" alt="flèche" />
                            </div>
                            <div id="map">
                                <iframe id='g_map' src=" https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2527.506590296966!2d4.015692615871126!3d50.69198307781253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c3b220b60b9cc7%3A0x81b95959d74b3155!2sEns+Promo+Sociale+Enghien!5e0!3m2!1sfr!2sbe!4v1480877268176" allowFullScreen></iframe>
                            </div>
                        </div>
                        <div className="droite">
                            <p className="ouverture">Nous sommes ouverts du lundi au vendredi de 8h15 à 16h (le mercredi jusqu'à 12h) et du lundi au jeudi de 18h25 à 19h30. </p>
                            <p className="contact-infos"><img src="/images/socials/home.svg" alt="home" /> 50 rue du village 7850 Enghien</p>
                            <p className="contact-infos"><img src="/images/socials/phone.svg" alt="phone" /> 02/395.60.23</p>
                            <p className="contact-infos"><img src="/images/socials/email.svg" alt="e-mail" /> <a href="mailto:info@epse.be">info@epse.be</a></p>
                            <p className="social-contact">Ou suis-nous sur les <span>réseaux sociaux</span></p>
                            <div id="social-links-contact">
                                <a className='social-link' href="https://www.linkedin.com/school/epse/" target="_blank">
                                    <img src="/images/socials/linked_c.svg" alt="EPSE LinkedIn" />
                                </a>
                                <a className='social-link' href="https://www.facebook.com/EPSEMarcq/" target="_blank">
                                    <img src="/images/socials/facebook_c.svg" alt="EPSE Facebook" />
                                </a>
                                <a className='social-link' href="https://www.youtube.com/channel/UC33Fs4BdaHlEb5GfDoZzSsA?view_as=subscriber" target="_blank">
                                    <img src="/images/socials/youtube_c.svg" alt="EPSE YouTube" />
                                </a>
                                <a className='social-link' href="https://www.tiktok.com/@e.p.s.e" target="_blank">
                                    <img src="/images/socials/tiktok_c.svg" alt="EPSE TikTok" />
                                </a>
                                <a className='social-link' href="https://www.instagram.com/e.p.s.e/" target="_blank">
                                    <img src="/images/socials/insta_c.svg" alt="EPSE Instagram" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div id="help">
                        Besoin de plus de détails ? Rendez-vous sur <a href="https://www.epse.be/contact">EPSE.be</a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Contact;